import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from '@app/App.vue';
import router from '@app/router/index.APP_TARGET';
import coreModule from '@core/core.module';
import sharedModule from '@shared/shared.module';
import devModule from '@dev/dev.module';
import posModule from '@pos/pos.module';
import toolsModule from '@tools/tools.module';
import store from '@app/store';
import '@themes/architectui/architectui';

const devModuleActivated = process.env.VUE_APP_ACTIVATE_DEV_MODULE === 'true';
const defaultLang = process.env.VUE_APP_DEFAULT_LANG || 'fr'; // TODO Change this to be loaded from .env file
const lang = localStorage.getItem('lang') || store.getters['auth/userLang'] || defaultLang;

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: lang, // set locale
  messages: null, // The lang file is requested to API in translation.service.ts
  silentTranslationWarn: true,
});

Vue.use(coreModule);
Vue.use(sharedModule);

if (devModuleActivated) {
  Vue.use(devModule);
}

Vue.use(posModule);
Vue.use(toolsModule);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  i18n,
}).$mount('#app');
